

















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as _ from 'underscore'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import { sleep } from '@ivy/fts/utils'
@Component({
  components: {},
})
export default class TestPage extends Vue {
  @Prop({ default: [] }) info: any[]
  @Prop({ default: '' }) introduction_text: string
  testInfo: any = []
  currentIndex = 0
  closed: boolean = false
  timer: any
  show_bottom: boolean = true
  screenHeight: any = document.documentElement.clientHeight
  originHeight: any = document.documentElement.clientHeight
  betweenIndex = -1
  @Watch('screenHeight')
  screenRealHeight(val) {
    if (this.originHeight > val) {
      this.show_bottom = false
    } else {
      this.show_bottom = true
    }
  }
  getBgImg() {
    if (this.testInfo[this.currentIndex].totalScore === 0)
      return require('./imgs/next_Quest@3x.png')
    return require('./imgs/be-assigned@3x.png')
  }
  created() {
    this.testInfo = JSON.parse(JSON.stringify(this.info))
  }
  mounted() {
    let scrollList: any = this.$refs.scrollList
    scrollList &&
      scrollList.style &&
      (scrollList.style.transform = `translateX(${-this.currentIndex * 100}vw)`)
    window.onresize = () =>
      (() => {
        this.screenHeight = document.documentElement.clientHeight
      })()
  }
  async goPre() {
    this.closed = true
    this.betweenIndex = this.currentIndex
    this.currentIndex--
    this.$nextTick(async () => {
      await sleep(550)
      this.betweenIndex = -1
    })
  }
  // 判断值是否符合，不符合的进行处理
  checkInput(e, secindex) {
    let total = 0
    let score = +e.target.value.replace(/\D/g, '')
    let sumScore = this.testInfo[this.currentIndex].sumScore
    total = this.testInfo[this.currentIndex].options
      .map((o, index) => {
        if (index !== secindex) {
          return +o.score
        } else {
          return 0
        }
      })
      .reduce((score_i, num) => {
        return score_i + num
      })
    let inputScore =
      score <= 0 ? 0 : score > sumScore - total ? sumScore - total : score
    this.$nextTick(() => {
      this.testInfo[this.currentIndex].options[secindex].score = inputScore
      this.testInfo[this.currentIndex].totalScore =
        sumScore - total - inputScore
    })
  }
  checkNumber(secindex, score) {
    let total = 0
    let sumScore = this.testInfo[this.currentIndex].sumScore
    total = this.testInfo[this.currentIndex].options
      .map((o, index) => {
        if (index !== secindex) {
          return +o.score
        } else {
          return 0
        }
      })
      .reduce((score_i, num) => {
        return score_i + num
      })
    let inputScore =
      score <= 0 ? 0 : score > sumScore - total ? sumScore - total : score
    this.testInfo[this.currentIndex].options[secindex].score = inputScore
    this.testInfo[this.currentIndex].totalScore = sumScore - total - inputScore
  }
  // 单项加分，可用分减去
  add(index) {
    let pageSelection = this.testInfo[this.currentIndex]
    let selectionscore = this.testInfo[this.currentIndex].options[index].score
    if (pageSelection.totalScore > 0) {
      if (pageSelection.totalScore - 10 >= 0) {
        this.testInfo[this.currentIndex].options[index].score =
          +selectionscore + 10
        this.testInfo[this.currentIndex].totalScore =
          +pageSelection.totalScore - 10
      } else {
        this.testInfo[this.currentIndex].options[index].score =
          +selectionscore + pageSelection.totalScore
        this.testInfo[this.currentIndex].totalScore = 0
      }
    } else {
      return this.$Toast('无剩余分数')
    }
  }
  // 单项减分，可用分加上
  reduce(index) {
    let pageSelection = this.testInfo[this.currentIndex]
    let selectionscore = this.testInfo[this.currentIndex].options[index].score
    if (selectionscore > 0) {
      if (selectionscore - 10 >= 0) {
        this.testInfo[this.currentIndex].options[index].score =
          +selectionscore - 10
        this.testInfo[this.currentIndex].totalScore =
          pageSelection.totalScore + 10
      } else {
        this.testInfo[this.currentIndex].options[index].score = 0
        this.testInfo[this.currentIndex].totalScore =
          pageSelection.totalScore + selectionscore
      }
    }
  }
  handleFocus() {
    this.show_bottom = false
    clearTimeout(this.timer)
  }
  handleBlur() {
    this.timer = setTimeout(() => {
      this.show_bottom = true
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }, 100)
  }
  async goNext() {
    if (this.testInfo[this.currentIndex].totalScore) return
    if (this.currentIndex + 1 === this.testInfo.length) {
      this.$emit('getResult', this.testInfo)
    } else {
      this.closed = true
      this.betweenIndex = this.currentIndex
      this.currentIndex++
      this.$nextTick(async () => {
        await sleep(550)
        this.betweenIndex = -1
      })
    }
  }
}
